<button
  type="button"
  class="support-widget__fab"
  [class.support-widget__fab--open]="isOpen"
  [attr.aria-expanded]="isOpen"
  aria-label="Поддержка Glabix"
  (click)="toggle()"
>
  @if (isOpen) {
    <span aria-hidden="true">×</span>
  } @else {
    <span aria-hidden="true">💬</span>
  }
</button>

@if (isOpen) {
  <section class="support-widget__panel" role="dialog" aria-label="Чат с поддержкой Glabix">
    <header class="support-widget__header">
      <div class="font-weight-500">Поддержка Glabix</div>
      <button type="button" class="support-widget__close" aria-label="Закрыть" (click)="close()">×</button>
    </header>

    <div class="support-widget__feed" #scrollContainer>
      @if (isBooting || (loading && messages.length === 0)) {
        <div class="flex items-center justify-center py-8">
          <span class="i i-spinner i--spin i--lg text-gray-400"></span>
        </div>
      } @else if (messages.length === 0) {
        <div class="support-widget__empty text-gray">Напишите первое сообщение — мы ответим в рабочее время.</div>
      } @else {
        @for (message of messages; track message.id) {
          @if (message.kind === "user_message" || message.kind === "agent_message") {
            <div
              class="support-widget__bubble"
              [class.support-widget__bubble--own]="isOwnMessage(message)"
              [class.support-widget__bubble--peer]="!isOwnMessage(message)"
              [class.support-widget__bubble--deleted]="!!message.deleted_at"
            >
              @if (message.deleted_at) {
                <em class="text-gray">Сообщение удалено</em>
              } @else {
                <div class="support-widget__body">{{ message.body }}</div>
                <div class="support-widget__meta">
                  {{ message.created_at | date: "HH:mm" }}
                  @if (message.edited_at) {
                    · изменено
                  }
                </div>
              }
            </div>
          }
        }
      }
    </div>

    @if (workingHours) {
      <div class="support-widget__hint text-gray">{{ workingHours }}</div>
    }

    <form class="support-widget__composer" (submit)="$event.preventDefault(); send()">
      <textarea
        #textarea
        class="support-widget__textarea"
        rows="2"
        placeholder="Ваше сообщение…"
        [value]="body"
        (input)="onBodyInput($event)"
        (keydown.enter)="handleEnter($event)"
        (keydown.shift.enter)="preventShiftEnter($event)"
        [disabled]="isSending || !chat"
      ></textarea>
      <button type="submit" class="support-widget__send" [disabled]="!canSend">Отправить</button>
    </form>
  </section>
}
